import React, { PureComponent } from 'react';

import { translate } from '../utils';
import { is768Query } from '~/core/scripts/mediaquery-helper';

class YAxis extends PureComponent {
  render() {
    const {
      margin,
      ticks,
      y,
      unit,
      drawTickLines,
      height,
      isTeaser
    } = this.props;
    const isSmallScreen = !is768Query() || isTeaser;
    const textAnchor = isSmallScreen ? 'start' : 'end';
    const translateX = isSmallScreen ? 0 : margin.left + 0.5;
    const lineX2 = isSmallScreen ? 4 : -6;
    const textX = isSmallScreen ? 5 : -9;

    return (
      <g
        className="chart__yaxis chart__axis"
        textAnchor={textAnchor}
        transform={translate(translateX, 0)}
      >
        <line
          className="domain"
          stroke="currentColor"
          x1={0}
          y1="0"
          x2={0}
          y2={height - margin.bottom}
        />
        {ticks.map(d => (
          <g
            className="tick"
            transform={translate(0, ~~y(d.value) + 0.5)}
            key={`yaxis__${d.value}`}
          >
            {drawTickLines && <line stroke="currentColor" x2={lineX2} />}
            <text fill="currentColor" x={textX} dy="0.32em">
              {d.label}
              {unit ? ` ${unit}` : ''}
            </text>
          </g>
        ))}
      </g>
    );
  }
}

export default YAxis;
